<template>
    <div>
        <rkm-row
            v-if="verificarPermissao('destroy-ambulatorio-jornada') && jornadas.find(jornada => jornada.selecionada === true)"
            class="mt-3"
        >
            <rkm-col>
                <rkm-button
                    @click="destroyChecked"
                    color="danger"
                >
                    Excluir selecionado(s)
                </rkm-button>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="jornadas.length > 0" class="mt-2">
            <rkm-col>
                <rkm-form-checkbox-group
                    :options="optionalColumnsOptions"
                    buttons
                    button-color="outline-secondary"
                    class="toggle-columns"
                    label="Exibir/ocultar colunas"
                    text-field="label"
                    v-model="visibleOptionalColumns"
                    value-field="key"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-2">
            <rkm-col>
                <rkm-table
                    :fields="fields"
                    :items="jornadas"
                    @filter-changed="handleFilterChanged"
                    @filtered="jornadasFiltered = $event"
                >
                    <template v-slot:head(checkboxes)>
                        <rkm-form-checkbox
                            :indeterminate="indeterminate"
                            :value="true"
                            @change="checkUncheckAll"
                            v-model="checkedAll"
                        />
                    </template>

                    <template v-slot:cell(checkboxes)="{item}">
                        <rkm-form-checkbox
                            :disabled="!!item.temAgendamentos"
                            :value="true"
                            @change="handleCheckedAll"
                            v-model="item.selecionada"
                        />
                    </template>

                    <template v-slot:cell(actions)="{item}">
                        <rkm-button
                            @click="$refs.ModalCadastro.edit(item.id, item.totalAgendamentos)"
                            authorize="edit-ambulatorio-jornada"
                            color="primary"
                            small
                            title="Editar"
                        >
                            <rkm-icon icon="pen" />
                        </rkm-button>

                        <rkm-button
                            :disabled="!!item.temAgendamentos"
                            @click="destroy(item.id)"
                            authorize="destroy-ambulatorio-jornada"
                            color="danger"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>

        <ModalCadastro
            :usuario-id="usuarioId"
            @updated="$emit('updated', $event)"
            ref="ModalCadastro"
        />
    </div>
</template>

<script>
// Components.
import ModalCadastro from '@/components/ambulatorio/jornada/components/cadastro/Modal'

// Mixins.
import {error, formats, permissao, repository, stringCase} from '@/mixins'

export default {
    components: {ModalCadastro},
    computed: {
        optionalColumnsOptions() {
            const options = [
                {key: 'tempoConsulta', label: 'Tempo da consulta'},
                {key: 'tempoRetorno', label: 'Tempo do retorno'},
            ]

            if (this.isEspecialidadeConectasusCidadao) {
                options.push(
                    {key: 'tempoConsultaConectasusCidadao', label: 'Tempo consulta App Cidadão'},
                    {key: 'tempoRetornoConectasusCidadao', label: 'Tempo retorno App Cidadão'},
                )
            }

            options.push(
                {key: 'permiteAgendamentoSomenteSupervisor', label: 'Agendamento apenas supervisor'},
                {key: 'tipoAgendamentoSafecare', label: 'Agendamento Aplicativo'},
            )

            return options
        },
        fields() {
            const fields = []

            if (this.verificarPermissao('edit-ambulatorio-jornada') || this.verificarPermissao('destroy-ambulatorio-jornada')) {
                fields.push({key: 'checkboxes', label: '#', class: 'col-min text-center'})
            }

            fields.push(
                {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                {key: 'ocupacaoDescricao', label: 'CBO', sortable: true},
                {key: 'especialidadeNome', label: 'Especialidade', sortable: true},
                {key: 'tipoNome', label: 'Tipo', sortable: true},
                {formatter: value => this.formatDate(value), filterByFormatted: true, key: 'data', label: 'Data', sortable: true},
                {key: 'diaSemana', label: 'Dia da semana', sortable: true},
                {key: 'inicio', label: 'Inicio', sortable: true},
                {key: 'fim', label: 'Fim', sortable: true},
                {key: 'situacaoNome', label: 'Situação', sortable: true},
                {key: 'quantidadeConsulta', label: 'Quantidade de consultas', sortable: true},
                {key: 'quantidadeRetorno', label: 'Quantidade de retornos', sortable: true},
            )

            if (this.isEspecialidadeConectasusCidadao) {
                fields.push(
                    {key: 'quantidadeConsultaConectasusCidadao', label: 'Consultas App Cidadão', sortable: true},
                    {key: 'quantidadeRetornoConectasusCidadao', label: 'Retornos App Cidadão', sortable: true},
                )
            }

            fields.push({key: 'totalAgendamentos', label: 'Total de agendamentos', sortable: false})

            if (this.visibleOptionalColumns.includes('tempoConsulta')) {
                fields.push({key: 'tempoConsulta', label: 'Tempo da consulta', sortable: true})
            }

            if (this.visibleOptionalColumns.includes('tempoRetorno')) {
                fields.push({key: 'tempoRetorno', label: 'Tempo do retorno', sortable: true})
            }

            if (this.isEspecialidadeConectasusCidadao && this.visibleOptionalColumns.includes('tempoConsultaConectasusCidadao')) {
                fields.push({key: 'tempoConsultaConectasusCidadao', label: 'Tempo consulta App Cidadão', sortable: true})
            }

            if (this.isEspecialidadeConectasusCidadao && this.visibleOptionalColumns.includes('tempoRetornoConectasusCidadao')) {
                fields.push({key: 'tempoRetornoConectasusCidadao', label: 'Tempo retorno App Cidadão', sortable: true})
            }

            if (this.visibleOptionalColumns.includes('permiteAgendamentoSomenteSupervisor')) {
                fields.push({formatter: value => value ? 'SIM' : 'NÃO', filterByFormatted: true, key: 'permiteAgendamentoSomenteSupervisor', label: 'Permitir agendamento apenas para o supervisor', sortable: true})
            }

            if (this.visibleOptionalColumns.includes('tipoAgendamentoSafecare')) {
                fields.push({formatter: value => value ? 'SIM' : 'NÃO', filterByFormatted: true, key: 'tipoAgendamentoSafecare', label: 'Agendamento Aplicativo', sortable: true})
            }

            if (this.verificarPermissao('edit-ambulatorio-jornada') || this.verificarPermissao('destroy-ambulatorio-jornada')) {
                fields.push({key: 'actions', label: 'Ações', class: 'col-min text-center'})
            }

            return fields
        },
    },
    created() {
        this.repositories = {
            jornada: this.getConectaSusRepository('ambulatorio.jornada'),
        }
    },
    data: () => ({
        indeterminate: false,
        jornadasFiltered: [],
        checkedAll: false,
        visibleOptionalColumns: [],
    }),
    methods: {
        handleFilterChanged() {
            this.checkedAll = false
            this.indeterminate = false
            this.jornadas.map(jornada => jornada.selecionada = false)
        },
        handleCheckedAll() {
            this.checkedAll = false
            this.indeterminate = false

            const quantidadeJornadas = this.jornadasFiltered.filter(jornada => jornada.temAgendamentos === false).length

            const quantidadeJornadasSelecionadas = this.jornadas
                .filter(jornada => this.jornadasFiltered.find(jornadaFiltered => jornadaFiltered.id === jornada.id))
                .filter(jornada => jornada.selecionada === true).length

            if (quantidadeJornadasSelecionadas > 0) {
                if (quantidadeJornadasSelecionadas === quantidadeJornadas) {
                    this.checkedAll = true
                } else  {
                    this.indeterminate = true
                }
            }
        },
        checkUncheckAll(value) {
            this.checkedAll = value
            this.indeterminate = false

            this.jornadas
                .filter(jornada => this.jornadasFiltered.find(jornadaFiltered => jornadaFiltered.id === jornada.id) && jornada.temAgendamentos === false)
                .map(jornada => jornada.selecionada = value)
        },
        destroy(id) {
            const destroy = () => this.repositories.jornada.destroy(id)
                .then(() => {
                    this.jornadas.splice(this.jornadas.findIndex(jornada => jornada.id === id), 1)
                    this.handleCheckedAll()
                })

            this.showDeleteConfirmation('Deseja realmente excluir a jornada?', destroy, this.handleError)
        },
        destroyChecked() {
            const ids = this.jornadas.filter(jornada => jornada.selecionada === true).map(jornada => jornada.id)

            const destroy = () => this.repositories.jornada.destroyAll(this.camelObjectKeysToSnakeRecursive({ids: ids}))
                .then(response => {
                    let warning = ''
                    let message = ''

                    if (response.data.jornadasIdsComAgendamento.length > 0) {
                        response.data.jornadasIdsComAgendamento.forEach(id => {
                            const jornada = this.jornadas.find(jornada => jornada.id === id)

                            message = message + `<li>
                                Dia ${jornada.data} - ${jornada.diaSemana},
                                das ${jornada.inicio}
                                às ${jornada.fim}
                            </li>`
                        })

                        warning = warning + `
                            Jornada(s) com agendamento(s)
                            <ul>${message}</ul>
                        `
                    }

                    response.data.jornadasIdsExcluidos.forEach(id => {
                        this.jornadas.splice(this.jornadas.findIndex(jornada => jornada.id === id), 1)
                    })

                    if (warning) {
                        this.$nextTick().then(() => this.showWarningNotification(warning))
                    }

                    this.handleCheckedAll()
                })

            this.showDeleteConfirmation('Deseja realmente excluir a(s) jornada(s) selecionada(s)?', destroy, this.handleError)
        },
    },
    mixins: [error, formats, permissao, repository, stringCase],
    props: {
        isEspecialidadeConectasusCidadao: {type: Boolean, default: false},
        jornadas: {type: Array, required: true},
        usuarioId: {type: [Number, String], required: true},
    },
    watch: {
        jornadas(value) {
            this.checkedAll = false
            this.indeterminate = false
            this.jornadasFiltered = value
        },
    },
}
</script>

<style scoped>
.toggle-columns >>> .btn-group {
    flex-wrap: wrap;
}
</style>
